import { ProcessingView } from '@/components/progress/ProcessingView/ProcessingView';

export function MemoProcessingView() {
  return (
    <ProcessingView
      title="Memo in progress"
      subtitle="Memos can take a few minutes to generate. You can exit this screen."
    />
  );
}
